import { Button } from '../Button/Button';

type CookieConsentOverlayType = {
  description: string;
  buttonLabel: string;
};

export const CookieConsentOverlay = ({
  description,
  buttonLabel,
}: CookieConsentOverlayType) => {
  return (
    <div
      className="flex h-full w-full flex-col items-center justify-center bg-black p-4"
      data-test="cookie-consent-required-notice"
    >
      <div className="mb-6 w-full text-center text-xs text-white xl:w-2/3 xl:text-sm">
        {description}
      </div>
      <Button
        label={buttonLabel ?? ''}
        isDarkMode={true}
        style="secondary"
        className="ot-sdk-show-settings text-xs tracking-[0.08rem] lg:text-sm lg:tracking-wide"
      />
    </div>
  );
};
